import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ as FAQT } from "@/constants/testIds";

const ITEMS = [
  {
    key: "software",
    q: "Is this software I buy?",
    a: "No. It's a service. You get trained people augmented by AI, delivering outcomes — not a tool to set up and staff yourself.",
  },
  {
    key: "sops",
    q: "What about our existing SOPs?",
    a: "We ingest them. Your processes, checklists, and references become what our agents and Ally work from. If they're messy or incomplete, we help formalize them.",
  },
  {
    key: "isolation",
    q: "Is our data isolated from other clients?",
    a: "Yes. Every client's work is scoped to their own tenant — one client's people, processes, and records never surface to another.",
  },
  {
    key: "legacy",
    q: "Do we have to replace our legacy systems?",
    a: "No. We integrate with what you run, pull from it, and bring the results together in your Vault — even systems that don't normally talk to anything. No forced migration.",
  },
  {
    key: "supervision",
    q: "Who supervises the agents?",
    a: "Both. A supervising AI reviews and coaches the work continuously, and our operations team stays in the loop. Nothing runs set-and-forget.",
  },
  {
    key: "speed",
    q: "How fast can we be live?",
    a: "Our target is under a week from kickoff to a process running.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid={FAQT.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-20">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65">
              <span className="eyebrow-bar" aria-hidden="true" />
              <span>FAQ</span>
            </div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest max-w-3xl text-[#0a0a0a]">
              Questions,
              <span className="italic font-light text-black/65"> answered.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-3 hidden md:block" />
          <div className="md:col-span-9">
            <Accordion type="single" collapsible className="border-t border-black/15">
              {ITEMS.map((it) => (
                <AccordionItem
                  key={it.key}
                  value={it.key}
                  data-testid={FAQT.item(it.key)}
                  className="border-b border-black/15"
                >
                  <AccordionTrigger className="text-left hover:no-underline py-7 group text-[#0a0a0a]">
                    <span className="font-serif text-xl md:text-2xl lg:text-[26px] tracking-tight leading-snug pr-6">
                      {it.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 font-sans text-black/70 text-base md:text-[17px] leading-relaxed max-w-3xl">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
